import LogoImg from "../../assets/images/mtc-logo.svg";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import "./logo.scss";

function Logo(props) {
  const { t } = useTranslation("common");
  return (
    <div className={classnames("macalan-logo", props.type)}>
      <button
        aria-label={`${t("button.dashboard_line1")} ${t(
          "button.dashboard_line2"
        )}`}
        onClick={props.onClick}
      >
        <img
          src={LogoImg}
          alt={t("nav.macallan_logo")}
          className="img-responsive"
        />
      </button>
    </div>
  );
}

export default Logo;
